import React from 'react';
import PropTypes from 'prop-types';
import { EmojiIcon } from '../EmojiIcon';
import styles from './PauseSlideContentV12.css';

function PauseSlideContentV12({ spriteVersion }) {
    return (
        <div className={styles.form}>
            <div className={styles.headingSection}>
                <h2 className={styles.heading}>There’s no one way to live a rich life</h2>
                <p className={styles.description}>
                    Sometimes it looks like a badly timed laugh, a story your parents never heard, or a rule you chose not to follow.
                    <br /><br />
                    {'These aren’t '}<strong>random moments.</strong>{' They’re clues to what shaped you.'}
                </p>
            </div>
            <div className={styles.highlight}>
                <EmojiIcon name='refresh' version={spriteVersion} className={styles.highlightIcon} />
                <p className={styles.highlightText}>Let’s look at the turning points</p>
            </div>
        </div>
    );
}

PauseSlideContentV12.propTypes = {
    spriteVersion: PropTypes.string.isRequired
};

export {
    PauseSlideContentV12
};
